<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="70%"
    top="5vh"
  >
    <el-form
      :ref="formRef"
      :rules="rules"
      :model="KPowerform"
      label-width="150px"
    >
      <el-row :gutter="24">
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="kTypeId" :label="$t('title.productLine')">
            <el-select
              @change="selMTChange"
              v-model="KPowerform.kTypeId"
              :placeholder="$t('desc.select')"
              style="width: 100%"
            >
              <el-option
                v-for="item in MTypeTable"
                :key="item.id"
                :label="item.kType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item
            prop="kProductId"
            :label="$t('title.productCategories')"
          >
            <el-select
              @change="selMPChange"
              v-model="KPowerform.kProductId"
              :placeholder="$t('desc.select')"
              style="width: 100%"
            >
              <el-option
                v-for="item in MProductTable"
                :key="item.id"
                :label="item.modelDesc"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="kSmallId" :label="$t('title.smallClassProduct')">
            <el-select
              v-model="KPowerform.kSmallId"
              :placeholder="$t('desc.select')"
              style="width: 100%"
            >
              <el-option
                v-for="item in MSmallTable"
                :key="item.id"
                :label="item.modelDesc"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="kPower" :label="$t('title.machineType')">
            <el-input
              v-model="KPowerform.kPower"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="productFamily" :label="$t('title.productFamily')">
            <el-select
              v-model="KPowerform.productFamily"
              :placeholder="$t('desc.select')"
              filterable 
              style="width: 100%"
              @change="changeProoduct"
            >
              <el-option
                v-for="item in productFamilyList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <!-- <el-input
              v-model="KPowerform.productFamily"
              style="width: 100%"
            ></el-input> -->
          </el-form-item>
        </el-col>
        <el-col  :md="12" :xs="24" :sm="24">
          <el-form-item v-if="isShowOtherInput === true"  prop="productFamilyName" :label="$t('title.productFamilyName')">
            <el-input
            v-if="isShowOtherInput === true"
              v-model="KPowerform.productFamilyName"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="power" :label="$t('title.power')">
            <el-input
            type='number'
              v-model.number="KPowerform.power"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="dischargePressure" :label="$t('title.dischargePressure')">
            <el-input
            type='number'
              v-model.number="KPowerform.dischargePressure"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="coolingMode" :label="$t('title.coolingMode')">
            <el-input
              v-model="KPowerform.coolingMode"
              style="width: 100%"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24" :sm="24">
          <el-form-item prop="brandCode" :label="$t('title.brand')">
            <el-select style="width: 200px" @change="changeBrand" v-model="KPowerform.brandCode" :placeholder="$t('desc.select')">
              <el-option
                :label="brandInfo.brandName"
                :value="brandInfo.brandCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="24" :xs="24" :sm="24">
          <el-form-item prop="img" :label="$t('title.modelImage')">
            <!-- 单击选中一张图片后，在 <div class="pic">的div上增加class名active -->
            <div class="deviceimgDiv">
              <el-row :gutter="24" class="PicList">
                <el-col
                  :md="4"
                  :sm="6"
                  :xs="12"
                  v-for="(item,index) in picList"
                  :key="item.id"
                >
                  <div @click="selImag(index,item.id)" :ref="'ref_'+index" class="pic" :class="{active:index==imgDiv}">
                    <!-- <div class="pic active"> 为选中一张图片后的class样式-->
                    <i class="el-icon-check"></i>
                    <el-image
                      style="width: 100%; height: 100px"
                      :src="item.imageUrl"
                      fit="contain"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <span class="demonstration">{{ item.title }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
        </el-col>
        <el-col :md="24" :xs="24" :sm="24">
          <el-form-item>
            <el-button
              :loading="loading"
              v-if="subButtonAuth"
              type="success"
              @click="onSubBtn(formRef)"
              >{{ $t("button.confirm") }}</el-button
            >
            <el-button @click="doClose">{{ $t("button.cancel") }}</el-button>
          </el-form-item>
        </el-col></el-row
      >
    </el-form>
  </el-dialog>
</template>

<script>
import {getBrandInfos} from "../../../api/api"
export default {
  name: "index",
  props: {
    loading:false,
    picList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    subButtonAuth: false,
    title: "",
    formRef: "",
    dialogAddClient: false,
    dialogAddMethod: false,
    KPowerform: {
      KTypeId: "",
      KType: "",
      KProductId: "",
      kProduct: "",
      KSmallId: "",
      KSmall: "",
      KPower: "",
      KPowerId: "",
      ImgId:"",
    },
    imageId:"",
    MTypeTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
    MProductTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
    MSmallTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
    brandInfo:{},
    productFamilyList:{
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    imageId: {
      handler(newValue, oldValue) {
        for (let index = 0; index < this.picList.length; index++) {
          if (this.picList[index].id==newValue) {
            this.selImag(index,newValue)
          };
        }
      },
      // deep: true,
    },
    KPowerform: {
      handler(newValue, oldValue) {
        if(newValue && newValue.productFamily==='其它'){
          this.isShowOtherInput=true;
        }else{
          this.isShowOtherInput=false;
        }
      },
      deep: true,
    },
  },
  created() {
    this.$watch("imgDiv", function (newValue, oldValue) {
    //console.log(newValue)
    })
  },
  data() {
    return {
    isShowOtherInput:false,
      imgDiv:-1,
      imgId:"",
      rules: {
        productFamilyName:[
          { required: true, message: this.$t('tips.needed'), trigger: "blur" },
        ],
        productFamily:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        power:[{type: 'number', required:true, message: this.$t('tips.mustNumebr'), trigger: ['blur','change']}],
        dischargePressure:[{type: 'number', required:true, message: this.$t('tips.mustNumebr'), trigger: ['blur','change']}],
        coolingMode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        brandCode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        kTypeId: [
          {
            required: true,
            message: this.$t("tips.needed"),
            trigger: ["blur", "change"],
          },
        ],
        kProductId: [
          {
            required: true,
            message: this.$t("tips.needed"),
            trigger: ["blur", "change"],
          },
        ],
        kSmallId: [
          {
            required: true,
            message: this.$t("tips.needed"),
            trigger: ["blur", "change"],
          },
        ],
        kPower: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
        ],
      },
      
    };
  },
  methods: {
    changeProoduct(){
      if(this.KPowerform.productFamily==='其它'){
        this.isShowOtherInput=true;
      }else{
        this.isShowOtherInput=false;
      }
    },
    changeBrand(){
      this.$emit("changeBrand", this.KPowerform.brandCode);
    },
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
          this.imgId="";
      this.imgDiv=-1;
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.formRef].resetFields();
      this.imgId="";
      this.imgDiv=-1;
      // this.$emit("selImag", this.imgId);
    },
    selMTChange(value) {
      this.$emit("selMTChange", value);
    },
    selMPChange(value) {
      this.$emit("selMPChange", value);
    },
    //选中图片加上样式 并将id传给父组件
    selImag(index,id){
      if (this.imgDiv==index) {
        this.imgDiv=-1;
        this.imgId="";
      }else{
        this.imgDiv=index;
        this.imgId=id;
      }
      this.$emit("selImag", this.imgId);
    }
  },
};
</script>

<style>
</style>
